module.exports = __webpack_public_path__ + "static/img/wz_gg_xp.27f2e5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/wz_gg_xp.png
// module id = LhHI
// module chunks = 2